import styled from 'styled-components';
import fonts from '../../../helpers/fonts';
import mediaQuery from '../../../helpers/mediaQuery';

export const IN_PAGE_NAV_TOP_IN_PX = 100;

export const InPageNavContainer = styled.div`
  position: relative;
  height: 100%;

  display: none;

  ${mediaQuery.tabletLandscape`
    display: block;
  `}
`;

export const Nav = styled.nav`
  position: sticky;
  top: ${IN_PAGE_NAV_TOP_IN_PX}px;
`;

export const NavHeading = styled.h2`
  ${fonts.headingXSmall}
  margin-top: 0;
`;

export const NavText = styled.span`
  display: inline-block;
`;
